module.exports = __webpack_public_path__ + "img/PD1505105410724593664.13df5958.png";